import React from 'react'

function SuperE1() {
  return (
    <div>

<p>
Saving to attain your financial goals is made easier by Britam’s Super E Plus. Better yet, your savings appreciate enabling you to gain much more value over time. How does it help you save?</p>
    <div className="my-4">
      <ul className="list-disc list-inside">
        <li>
          You get guaranteed bonuses of 130% of the sum assured paid in cash over the last 6 years of the policy.
        </li>
        <li>
          For policies lasting more than 10 years, you are entitled to a tax relief of up to 15% of the premium paid. Better yet, the full amount payable at the end of the policy is completely tax free.
        </li>
        <li>
          You are entitled to premium discounts each time you make a payment of KES 5,000 and above. This means, you are able to pay a lower premium for the same amount of cover.
        </li>
        <li>
          In case you miss a payment, all is not lost, you have until 60 days to pay your arrears and proceed with your policy as normal.
        </li>
      </ul>
    </div>
 





    </div>
  )
}

export default SuperE1